import { render } from "./PaymentHistoryModal.vue?vue&type=template&id=6480acbf&scoped=true"
import script from "./PaymentHistoryModal.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryModal.vue?vue&type=script&lang=js"

import "./PaymentHistoryModal.vue?vue&type=style&index=0&id=6480acbf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6480acbf"]])

export default __exports__